<div class="cpp-heading">
  <div class="cpp-heading__content">
    <h1 class="cpp-heading__title">{{labels['news.title.news']}}</h1>
  </div>
</div>

<u4-toolbar [results]="totalResults" [hint]="'query-help'">
  <u4-date-filter
    [startDate]="startDate"
    [endDate]="endDate"
    (filtered)="onDateFilter($event)">
  </u4-date-filter>
  <u4-cpp-search
    name="news-query"
    [value]="query"
    [placeholder]="labels['news.search.placeholder']"
    (searchInput)="onSearch($event)"
    [cssInput]="'cpp-input-product-assets'">
  </u4-cpp-search>
</u4-toolbar>

<div class="u4-card-grid" *ngIf="newsItemsList$ | async as newsItemsList$">
  <ng-container *ngIf="newsItemsList$.length; else no_results">
    <ng-container *ngFor="let newsItem of newsItemsList$; trackBy: trackByFn">
      <u4-cpp-card
        title="{{newsItem.title}}"
        subtitle="{{newsItem.publicationDate | date: 'd MMMM y'}}"
        [footer]="false"
        [link]="getLink(newsItem)">
        <img card-image loading="lazy" [attr.src]="getImage(newsItem)">
      </u4-cpp-card>
    </ng-container>
  </ng-container>
    <ng-template #no_results>
      <div class="u4-dynamic-view__empty">
        <p>{{ labels["faceted-search.label.no-results"] }}</p>
      </div>
    </ng-template>
</div>

<u4-cpp-pagination
  [totalResults]="this.totalResults"
  (pageNumberChange)="this.goToPage($event)"
  [class._is-hidden]="!this.totalResults || !(this.newsItemsList$ | async)"
  [pageNumber]="this.pageNumber"
  [pageSize]="this.pageSize"
></u4-cpp-pagination>

<div class="mt-3" *ngIf="totalResults">
  <u4-cpp-subscribe></u4-cpp-subscribe>
</div>


